import { MenuItem, TextField } from '@material-ui/core';
import React from 'react';

import { IIndexExchangeDSP } from '~/src/dash/api/deal-providers/indexExchange';

interface IIndexExchangeDSPSelectProps {
  name: string;
  label: string;
  onChange: (elem: React.ChangeEvent) => void;
  value: number;
  error: boolean;
  helperText: string;
}

const indexExchangeDSPs = [
  {
    dspID: 4,
    name: 'Amobee - Formerly Turn',
  },
  {
    dspID: 5,
    name: 'Advanced Store',
  },
  {
    dspID: 6,
    name: 'Zebestof',
  },
  {
    dspID: 7,
    name: 'InMarket',
  },
  {
    dspID: 8,
    name: 'Cognitiv',
  },
  {
    dspID: 9,
    name: 'RTB Iq',
  },
  {
    dspID: 10,
    name: 'Acuity',
  },
  {
    dspID: 11,
    name: 'Digital East',
  },
  {
    dspID: 13,
    name: 'Adot',
  },
  {
    dspID: 14,
    name: 'Loblaw',
  },
  {
    dspID: 15,
    name: 'Hawk (formerly TabMo)',
  },
  {
    dspID: 16,
    name: 'Surfside',
  },
  {
    dspID: 17,
    name: 'Zemanta',
  },
  {
    dspID: 18,
    name: 'DemandBase',
  },
  {
    dspID: 19,
    name: 'Moloco',
  },
  {
    dspID: 20,
    name: 'Criteo',
  },
  {
    dspID: 23,
    name: 'Liftoff',
  },
  {
    dspID: 24,
    name: 'LoopMe',
  },
  {
    dspID: 26,
    name: 'Taboola',
  },
  {
    dspID: 36,
    name: 'Criteo PTY',
  },
  {
    dspID: 39,
    name: 'The Trade Desk',
  },
  {
    dspID: 40,
    name: 'EQ Works',
  },
  {
    dspID: 41,
    name: 'AdGear',
  },
  {
    dspID: 44,
    name: 'Smaato',
  },
  {
    dspID: 47,
    name: 'Roku OneView (fka DataXu)',
  },
  {
    dspID: 48,
    name: 'Magnetic',
  },
  {
    dspID: 50,
    name: 'Eye Return',
  },
  {
    dspID: 51,
    name: 'BidSwitch',
  },
  {
    dspID: 53,
    name: 'Criteo UK',
  },
  {
    dspID: 55,
    name: 'Connexity',
  },
  {
    dspID: 56,
    name: 'A9',
  },
  {
    dspID: 57,
    name: 'SIZMEK DSP',
  },
  {
    dspID: 60,
    name: 'Criteo KK',
  },
  {
    dspID: 61,
    name: 'Ignition One Europe',
  },
  {
    dspID: 64,
    name: 'Basis DSP',
  },
  {
    dspID: 65,
    name: 'Conversant',
  },
  {
    dspID: 70,
    name: 'The Trade Desk - Video (Deprecated)',
  },
  {
    dspID: 72,
    name: 'AdGear - US',
  },
  {
    dspID: 73,
    name: 'Yahoo DSP',
  },
  {
    dspID: 81,
    name: 'Quantcast',
  },
  {
    dspID: 84,
    name: 'Meteora',
  },
  {
    dspID: 85,
    name: 'DV360',
  },
  {
    dspID: 87,
    name: 'Eye Return US',
  },
  {
    dspID: 88,
    name: 'Adobe - Video (Deprecated)',
  },
  {
    dspID: 89,
    name: 'Vizury',
  },
  {
    dspID: 90,
    name: 'Simplifi',
  },
  {
    dspID: 91,
    name: 'Dstillery',
  },
  {
    dspID: 92,
    name: 'Netmining',
  },
  {
    dspID: 94,
    name: 'MediaMath',
  },
  {
    dspID: 99,
    name: 'Xandr - Invest DSP (Appnexus)',
  },
  {
    dspID: 105,
    name: 'NextRoll',
  },
  {
    dspID: 106,
    name: 'Adobe',
  },
  {
    dspID: 109,
    name: 'Crimtan',
  },
  {
    dspID: 111,
    name: 'AdForm',
  },
  {
    dspID: 112,
    name: 'Bilin Technologies',
  },
  {
    dspID: 119,
    name: 'Pelmorex (formerly Addictive Mobility)',
  },
  {
    dspID: 123,
    name: 'Stackadapt - Video(Deprecated)',
  },
  {
    dspID: 130,
    name: 'Beeswax',
  },
  {
    dspID: 131,
    name: 'VDX (Formerly Exponential)',
  },
  {
    dspID: 133,
    name: 'RTBHouse',
  },
  {
    dspID: 135,
    name: 'Criteo Korea',
  },
  {
    dspID: 136,
    name: 'Criteo Advertising (Beijing) Co., Ltd.',
  },
  {
    dspID: 137,
    name: 'Criteo Singapore PTE LTD',
  },
  {
    dspID: 138,
    name: 'Criteo SAS',
  },
  {
    dspID: 139,
    name: 'Criteo GmbH',
  },
  {
    dspID: 140,
    name: 'Criteo BV',
  },
  {
    dspID: 141,
    name: 'Criteo Espana S.L.',
  },
  {
    dspID: 142,
    name: 'Criteo Nordics',
  },
  {
    dspID: 143,
    name: 'Criteo LLC',
  },
  {
    dspID: 144,
    name: 'Criteo MEA FZ LLC',
  },
  {
    dspID: 145,
    name: 'Criteo Reklamcilik Hizmetleri ve Ticaret A.S.',
  },
  {
    dspID: 146,
    name: 'Criteo SRL',
  },
  {
    dspID: 147,
    name: 'Criteo Canada CORP.',
  },
  {
    dspID: 148,
    name: 'Criteo do Brasil',
  },
  {
    dspID: 149,
    name: 'PowerLinks',
  },
  {
    dspID: 155,
    name: 'Criteo US',
  },
  {
    dspID: 156,
    name: 'Bidtellect',
  },
  {
    dspID: 157,
    name: 'Emerse',
  },
  {
    dspID: 161,
    name: 'Beeswax - EU (Deprecated)',
  },
  {
    dspID: 163,
    name: 'Stackadapt',
  },
  {
    dspID: 164,
    name: 'Smartology',
  },
  {
    dspID: 168,
    name: 'NativeAds',
  },
  {
    dspID: 170,
    name: 'Nanigans',
  },
  {
    dspID: 171,
    name: 'Juice Mobile - Display',
  },
  {
    dspID: 174,
    name: 'Juice Mobile - Video',
  },
  {
    dspID: 175,
    name: 'Delta',
  },
  {
    dspID: 176,
    name: 'Deep Intent',
  },
  {
    dspID: 178,
    name: 'IQM',
  },
  {
    dspID: 179,
    name: 'Adara',
  },
  {
    dspID: 180,
    name: 'Adelphic',
  },
  {
    dspID: 182,
    name: 'Main Ad',
  },
  {
    dspID: 183,
    name: 'Adelphic - Video (Deprecated)',
  },
  {
    dspID: 184,
    name: 'Samsung DSP (fka AdGear)',
  },
  {
    dspID: 185,
    name: 'YeahMobi',
  },
  {
    dspID: 186,
    name: 'Beeswax - Video (Deprecated)',
  },
  {
    dspID: 187,
    name: 'Media Smart',
  },
  {
    dspID: 188,
    name: 'AdTheorent',
  },
  {
    dspID: 189,
    name: 'PulsePoint',
  },
  {
    dspID: 190,
    name: 'Playground XYZ',
  },
  {
    dspID: 191,
    name: 'Knorex',
  },
  {
    dspID: 192,
    name: 'Zeta Global - Formerly Sizmek',
  },
  {
    dspID: 193,
    name: 'ClueP',
  },
  {
    dspID: 194,
    name: 'Remerge',
  },
  {
    dspID: 195,
    name: 'Advangelists',
  },
  {
    dspID: 196,
    name: 'Dynadmic',
  },
  {
    dspID: 197,
    name: 'Reset Digital',
  },
  {
    dspID: 198,
    name: 'Amazon',
  },
  {
    dspID: 199,
    name: 'Amazon- Video(Deprecated)',
  },
  {
    dspID: 200,
    name: 'Sift Media',
  },
  {
    dspID: 201,
    name: 'GroundTruth',
  },
  {
    dspID: 202,
    name: 'MadHive',
  },
  {
    dspID: 203,
    name: 'Appier',
  },
  {
    dspID: 204,
    name: 'PubWise',
  },
  {
    dspID: 205,
    name: 'Sqreem',
  },
  {
    dspID: 206,
    name: 'Scaleout DSP',
  },
  {
    dspID: 207,
    name: 'Clearpier',
  },
  {
    dspID: 208,
    name: 'Adrule',
  },
  {
    dspID: 209,
    name: 'UNICORN DSP',
  },
  {
    dspID: 210,
    name: 'RevX',
  },
  {
    dspID: 211,
    name: 'Bigabid',
  },
  {
    dspID: 212,
    name: 'NHN Ace Corp',
  },
  {
    dspID: 213,
    name: 'Aarki',
  },
  {
    dspID: 214,
    name: 'Bypass',
  },
  {
    dspID: 215,
    name: 'MediaGo',
  },
  {
    dspID: 216,
    name: 'Dynalist',
  },
  {
    dspID: 217,
    name: 'iDSP',
  },
  {
    dspID: 218,
    name: 'Edge226',
  },
  {
    dspID: 219,
    name: 'Index Test DSP',
  },
  {
    dspID: 220,
    name: 'MNTN',
  },
  {
    dspID: 221,
    name: 'Start.io',
  },
  {
    dspID: 222,
    name: 'Bidmachine',
  },
  {
    dspID: 223,
    name: 'Brightcom',
  },
  {
    dspID: 224,
    name: 'Arabyads',
  },
];

export const IndexExchangeDSPTargetingSelect = ({
  onChange,
  name,
  label,
  value,
  error,
  helperText,
}: IIndexExchangeDSPSelectProps) => {
  return (
    <TextField
      select
      fullWidth
      required
      name={name}
      type='number'
      label={label}
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
    >
      {indexExchangeDSPs.map((dsp: IIndexExchangeDSP) => {
        return (
          <MenuItem key={dsp.dspID} value={dsp.dspID}>
            {dsp.name}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
